module.exports = __webpack_public_path__ + "img/result-score.5627d766.png";